(() => {
  if (window.__soraFlowTracking) return;
  window.__soraFlowTracking = true;
  const accepted = new Set(["series_entry", "catalog_series_entry", "kitchen_series_entry", "shop_feature_lp", "recipe_early_lp", "recipe_bottom_lp", "recipe_early_product", "recipe_bottom_product", "sorafly_brand_lp", "product_lp"]);
  document.addEventListener("click", (event) => {
    const link = event.target.closest?.("a[data-sora-link], .sorasato-lp-links a, .sorafly-lp-links a");
    if (!link || event.defaultPrevented) return;
    const position = link.dataset.soraLink || "product_lp";
    if (!accepted.has(position)) return;
    try {
      const destination = new URL(link.href, window.location.origin);
      if (destination.origin !== window.location.origin) return;
      if (!new RegExp("^/(pages|products)/[^/?#]+$").test(destination.pathname)) return;
      const privacy = window.Shopify?.customerPrivacy;
      if (typeof privacy?.analyticsProcessingAllowed !== "function" || !privacy.analyticsProcessingAllowed()) return;
      if (typeof window.gtag !== "function") return;
      window.gtag("event", "sora_content_click", {
        link_position: position,
        destination_path: destination.pathname,
        content_item: /^[a-z0-9-]{1,100}$/.test(link.dataset.soraItem || "") ? link.dataset.soraItem : "unspecified",
        source_path: window.location.pathname
      });
    } catch (_) {}
  });
})();

